import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import { NFLookupDocument } from "./NFLookupDocument";
interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupCustomerSettlementAnalytics = ({ title, fieldName, required, showBorder, width, selectedCatalog, setSelectedCatalog }: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.CustomerSettlementAnalytics.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupDocument
        fieldName={fieldName}
        title={title}
        entity={AppEntities.CustomerSettlementAnalytics}
        width={width}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        {/* <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} /> */}
        <NFLookupCatalogColumn fieldName={"id"} caption={"id"} />
        <NFLookupCatalogColumn fieldName={"documentNumber"} caption={"documentNumber"} />
      </NFLookupDocument>
    </>
  );
};
